import React from "react";
import { CheckCircle } from "lucide-react";
import ITservicescycle from "./ITservicescycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Power Up Your Tech Company with WhatsApp",
  points: [
    "Reach more leads and turn them into customers with ease.",
    "Offer round-the-clock support to keep users happy.",
    "Perfect for startups, IT providers, and SaaS companies.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Book a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/lhsre1dbw7z4yuoz.webp?w=1024&dpr=2",
};

const techServices = [
  {
    id: 1,
    icon: <span className="text-2xl">💻</span>, // Laptop icon
    title: "Drive Software Sales with WhatsApp",
    description: "Promote your apps, tools, and subscriptions via WhatsApp campaigns. It’s like having a direct line to tech-savvy customers who act fast!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">🔧</span>, // Wrench icon
    title: "Offer Tech Support on WhatsApp",
    description: "Resolve software bugs, hardware issues, and queries in real time via WhatsApp. Your clients will appreciate the quick, personal service."
  },
  {
    id: 3,
    icon: <span className="text-2xl">📱</span>, // Phone icon
    title: "Launch Gadget Pre-Orders on WhatsApp",
    description: "Share sneak peeks, pre-order links, and launch updates through WhatsApp. It’s the perfect way to create buzz and drive sales."
  },
  {
    id: 4,
    icon: <span className="text-2xl">💡</span>, // Light bulb icon
    title: "Share Innovations via WhatsApp",
    description: "Keep your audience excited with tech tips, product demos, and industry news via WhatsApp. They’ll see you as a leader in innovation."
  },
  {
    id: 5,
    icon: <span className="text-2xl">📅</span>, // Calendar icon
    title: "Schedule Demos on WhatsApp",
    description: "Let prospects book product demos or consultations easily through WhatsApp. It’s flexible and builds trust from the first chat."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Collect Feedback with WhatsApp Surveys",
    description: "Ask for reviews on your products, services, or support via WhatsApp. It’s a quick way to refine your offerings and boost credibility."
  }
];


const techFAQs = [
  {
    question: "How can WhatsApp grow my tech business?",
    answer: "WhatsApp can boost your sales by promoting software, gadgets, and services directly to customers. It’s like having a sales rep who’s always pitching your latest innovations!"
  },
  {
    question: "Is WhatsApp secure for tech support?",
    answer: "Yes, WhatsApp’s encryption keeps your support chats and client data safe. It’s like locking your tech solutions in a fortress, so you can focus on solving problems."
  },
  {
    question: "Can customers buy tech products on WhatsApp?",
    answer: "Absolutely! They can order apps, accessories, or hardware via WhatsApp, with tracking and support all in one chat. It’s like shopping from a tech store that never closes."
  },
  {
    question: "How does WhatsApp handle tech customer support?",
    answer: "Offer real-time fixes for software bugs or hardware issues via WhatsApp. It’s like having a tech guru on speed dial, keeping customers happy and loyal."
  },
  {
    question: "What tech content should I share on WhatsApp?",
    answer: "Share product demos, industry trends, and update alerts via WhatsApp. It’s a direct line to keep your audience excited about your innovations and ready to buy."
  },
  {
    question: "Can WhatsApp schedule tech demos for clients?",
    answer: "Yes! Clients can book product demos or consultations via WhatsApp, with reminders to ensure they don’t miss out. It’s a flexible way to close more deals."
  },
  {
    question: "How do tech customers feel about WhatsApp?",
    answer: "They love it! Customers appreciate the speed, convenience, and personal touch of WhatsApp. It’s less formal than tickets and more immediate, making support a breeze."
  },
  {
    question: "Can WhatsApp reduce my tech company’s costs?",
    answer: "Definitely! Automate responses to common queries and handle support via WhatsApp, lowering overhead while improving service. It’s like getting more done with less!"
  },
  {
    question: "How can I collect feedback on WhatsApp for tech products?",
    answer: "Send surveys or ask for reviews on your products and services via WhatsApp. It’s a quick way to refine your offerings and build trust with new clients."
  },
  {
    question: "How do I integrate WhatsApp into my tech business?",
    answer: "Set up WhatsApp Business, create chat templates for sales and support, and use tools like ChatMitra to launch efficiently. It’s a simple step to power up your tech game!"
  },
];

const ITservices = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Power Up Your Tech Company with WhatsApp</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                <a
                key={index}
                href={button.buttonLink}
                className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
              >
                {button.text}
              </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Tech Company Leads" className="w-full h-auto rounded-lg shadow-md hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Ready to grow your tech business? Start with ChatMitra today—no credit card needed!</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <ITservicescycle />
      <WhatsAppServices servicesData={techServices} isVisible={true}/>
      <Faqs faqs={techFAQs} />

      <Footer />

      <title>WhatsApp for Tech Companies | ChatMitra</title>
      <meta name="description" content="Grow your tech company with WhatsApp. Boost leads, automate support, and onboard users seamlessly with ChatMitra." />
      <meta name="keywords" content="WhatsApp for tech, IT lead generation, SaaS onboarding, tech support automation, customer engagement" />
      <meta property="og:title" content="WhatsApp for Tech Companies | ChatMitra" />
      <meta property="og:description" content="Use WhatsApp to power up IT and SaaS companies with lead generation, 24/7 support, and smart automation." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-IT-services-and-internet" />
      <meta property="og:type" content="website" />
    </>
  );
};

export default ITservices;
